import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-datos-cancelacion',
  templateUrl: './datos-cancelacion.component.html',
  styleUrls: ['./datos-cancelacion.component.css']
})
export class DatosCancelacionComponent implements OnInit{

  @Output('')event = new EventEmitter();
  public adjuntosForm: FormGroup;

  constructor(private fb: FormBuilder, private storageService: StorageService) { 
    this.adjuntosForm = this.fb.group({
      idAnverso: ['', Validators.required],
      idReverso: ['', Validators.required],
      comprobanteDomicilio: ['', Validators.required]
    })
  }

  ngOnInit(){
    this.adjuntosForm.valueChanges.subscribe(res => {
      this.event.emit({...this.adjuntosForm.value});
    })
  }

  cargarAdjuntos(){
    console.log("cargar adjuntos a server: ", this.adjuntosForm.value);
    
  }
}
